import { useTranslation, i18n, SUPPORTED_LANGUAGES } from '@eon/i18n';
import { Card, CardContent, CardHeader, CardTitle, PageHeader, useTheme } from '@eon/ui';

export function SettingsPage() {
  const { t } = useTranslation();
  const { theme, setTheme } = useTheme();

  return (
    <>
      <PageHeader title={t('nav.settings')} />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle>{t('theme.toggle')}</CardTitle>
          </CardHeader>
          <CardContent>
            <select
              className="bg-background w-full rounded-md border px-3 py-2 text-sm"
              value={theme}
              onChange={(e) => setTheme(e.target.value as 'light' | 'dark' | 'system')}
            >
              <option value="dark">{t('theme.dark')}</option>
              <option value="light">{t('theme.light')}</option>
              <option value="system">System</option>
            </select>
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <CardTitle>{t('lang.label')}</CardTitle>
          </CardHeader>
          <CardContent>
            <select
              className="bg-background w-full rounded-md border px-3 py-2 text-sm"
              value={i18n.language}
              onChange={(e) => {
                void i18n.changeLanguage(e.target.value);
                localStorage.setItem('eon.lang', e.target.value);
              }}
            >
              {SUPPORTED_LANGUAGES.map((l) => (
                <option key={l} value={l}>
                  {t(`lang.${l}`)}
                </option>
              ))}
            </select>
          </CardContent>
        </Card>
      </div>
    </>
  );
}
